import type { BetslipApplicationState } from "../BetslipApplicationState";
import type { ConfirmationState } from "./confirmation.types";

export const getBetslipConfirmation = (state: BetslipApplicationState): ConfirmationState =>
  state.betslipConfirmation ?? null;
